import { ReactElement, useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { TabsProps } from 'antd';

import { LenderDetailsSection, LenderProcurationFeesSection } from '@pmp/components';
import { Page, StyledTabs } from '@ohpen/enso-ui';

export const LenderPage = (): ReactElement => {
  const { t } = useTranslation();

  const tabItems: TabsProps['items'] = useMemo(() => {
    const items = [
      {
        key: 'details',
        label: t('lender.lender.labels.details'),
        children: <LenderDetailsSection />,
      },
      {
        key: 'procuration-fees',
        label: t('lender.lender.labels.defaultProcurationFees'),
        children: <LenderProcurationFeesSection />,
      },
    ];

    return items;
  }, [t]);

  return (
    <Page>
      <Page.Title>{t('lender.lender.title')}</Page.Title>
      <Page.Content>
        <StyledTabs defaultActiveKey="details" items={tabItems} />
      </Page.Content>
    </Page>
  );
};
